import { z } from 'zod';
import { shiftParticipantHoursHistorySchema, } from '../shared/entities/shiftParticipantHoursHistoryTypes';
const addVolunteeringHoursParamsSchema = z.object({
    participationId: z.string().uuid(),
    shiftId: z.string().uuid(),
    shiftStartTime: z.number(),
    shiftStopTime: z.number(),
    missionOrganizationSharing: z.string().uuid().array(),
});
const addVolunteeringHoursResponseSchema = z.object({
    id: z.string().uuid(),
    data: shiftParticipantHoursHistorySchema.optional(),
    columns: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
});
const partialAddVolunteeringHoursResponseSchema = addVolunteeringHoursResponseSchema.omit({
    columns: true,
});
export const addVolunteeringHoursFunctionDef = {
    name: 'addVolunteeringHours',
    requestSchema: addVolunteeringHoursParamsSchema,
    responseSchema: addVolunteeringHoursResponseSchema.optional(),
};
